import { win } from "@gr-common/head/namespaces";
import type { OnexData } from "./index.js";

export function getAssignments(): OnexData {
  return win.__onex__ ?? {};
}
